module.exports = __webpack_public_path__ + "static/media/platinum.a2e880fa.svg";